import { createBrowserRouter } from "react-router";

import RootLayout from "app/layout";
import rootRoutes from "app/routes";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <div>Something went wrong</div>,
    children: rootRoutes,
  },
]);
